import { render } from "./McrFooter.vue?vue&type=template&id=26835311&scoped=true"
import script from "./McrFooter.vue?vue&type=script&lang=js"
export * from "./McrFooter.vue?vue&type=script&lang=js"

import "./McrFooter.vue?vue&type=style&index=0&id=26835311&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26835311"]])

export default __exports__